import { ContextModalProps } from '@mantine/modals'
import { EditProductForm } from 'components/productDetails/EditProductForm'
import { useEditProduct } from 'hooks/products'
import { EditProduct } from 'types/products'

type Props = {
  productId: string
  initialValues: Omit<EditProduct, 'id'>
}

export default function EditProductModal({
  context,
  id,
  innerProps: { productId, initialValues },
}: ContextModalProps<Props>) {
  const editProduct = useEditProduct()

  async function submit(values: Omit<EditProduct, 'id'>) {
    await editProduct.mutateAsync({ ...values, id: productId })
  }

  return <EditProductForm onCancel={() => context.closeModal(id)} onSubmit={submit} initialValues={initialValues} />
}
